import React, {Component} from 'react';
import {Row, Col, Card, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {SubmissionError} from 'redux-form';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import LaddaButton, {EXPAND_LEFT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import {Alert} from 'reactstrap';
import {toast} from "react-toastify";

const renderFieldLogin = ({name, input, label, type, meta: {touched, error}}) => {

    return (

        <InputGroup className="mb-3">
            <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="icon-user"></i>
                  </span>
            </div>
            <Input type="text" placeholder="Email"  {...input} />
        </InputGroup>

    )
};

const renderFieldPassword = ({name, input, label, type, meta: {touched, error}}) => {
    return (

        <InputGroup className="mb-4">
            <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="icon-lock"></i>
                  </span>
            </div>
            <Input type="password" placeholder="Mot de passe" {...input} />
        </InputGroup>

    )
};





class FormLogin extends Component {


    constructor(props) {

        super(props);

    }

    redirect(){
        const {history} = this.props
        history.push('/forgot-password')
    }



    render() {

        const {error, handleSubmit, pristine, reset, submitting} = this.props;




        return (

            <form onSubmit={handleSubmit}>


                {error && <Alert color="danger">{error}</Alert>}

                <Field
                    name="username"
                    component={renderFieldLogin}
                    type="text"
                />

                <Field
                    name="password"
                    component={renderFieldPassword}
                    type="text"
                />

                <Row>
                    <Col xs="6">

                        <LaddaButton
                            className="btn btn-success btn-ladda"
                            loading={submitting}
                            data-style={EXPAND_LEFT}
                            type={'submit'}
                        >
                            Se connecter </LaddaButton>
                    </Col>
                    <Col xs="6" className="text-right">
                        <Button onClick={() => this.redirect()} color="link" className="px-0">Mot de passe perdu
                            ?</Button>
                    </Col>
                </Row>
            </form>

        );
    }
}

FormLogin = reduxForm({
    form: 'FormLogin'
})(FormLogin);


export default FormLogin



// WEBPACK FOOTER //
// ./src/views/Pages/Login/formLogin.js